export default {
  title: "Поделиться новостями",
  description:
    "В данном разделе вы можете оставить заявку на размещение информации о вашей продукции или новостей о вашей компании на сайте выставки. ",
  sendButtonText: "Отправить заявку",
  modal: {
    title: "Поделиться новостями",
    title2: "Подать заявку",
    blueButtonText: "Добавить заявку",
    commentMaxLength: "До {count} символов",
    commentLabel: "Комментарий/примечание к размещению",
    headingInput: "Заголовок",
    headingMaxLength: "До {count} символов",

    applicationTypesLabel: "Тип заявки",
    applicationTypesNewsOption: "Новость",
    applicationTypesProductOption: "Продукция",

    dropzoneDownloadImages: "Загрузить изображение",
    dropzoneDropFiles: "Перетащите сюда файлы",
    dropzoneChooseFiles: "Выберите файлы",
    dropzoneFileSizeLimit:
      "Максимальное количество файлов: {count}, максимальный размер файла: {mb}Мб",
    dropzoneFilesType: "Допустимые типы файлов",
    dropzoneFileType: "Допустимые типы файла",
    dropzoneMaxFileSize: "Максимальный размер файла",
    dropzoneMaxFileSizeMessage: "Максимальное количество файлов",

    textEditorPlaceholder: "До {count} символов",
    textEditorToolsLabel: "Стили:",
    textEditorLabel: "Описание",

    fieldError: "Поле не может быть пустым",

    typeNews: "Новость",
    typeProduct: "Продукция",

    publicationLink: "Ссылка на публикацию",
    commentBlockHeading: "Комментарий к размещению",
    rejectReason: "Причина отклонения",

    statuses: {
      publish: "Опубликовано",
      draft: "Новая",
      reject: "Отклонено",
      progress: "В работе"
    }
  }
};
